import api from '@shared/services/api';

export const templateDocumentsService = {
    getTemplateDocumentsList: async () => {
        const response = await api.get('/hr-doc-templates/list');
        return response.data;
    },
    createTemplateDocument: async (formData) => {
        const response = await api.post('/hr-doc-templates', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },
    updateTemplateDocumentFile: async (id, file) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await api.post(`/hr-doc-templates/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },
    deleteTemplateDocument: async (id) => {
        const response = await api.delete(`/hr-doc-templates/${id}`);
        return response.data;
    },
};